import { createSlice } from "@reduxjs/toolkit";
import {
  getAllProductsService,
  createProductService,
  updateProductService,
  deleteProductService,
  getProductByIdService,
} from "../services/products_sevice";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  productList: [],
  metaProduct: null,
  productInfo: null,
  isLoadingAction: false,
};

const slice = createSlice({
  name: "products",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getAllProductsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productList = action.payload?.data?.data;
        state.metaProduct = action.payload.data.meta.meta;
      })
      .addCase(getAllProductsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllProductsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getProductByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientInfo = action.payload?.data?.data;
      })
      .addCase(getProductByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getProductByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(createProductService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(createProductService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(createProductService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      })
      .addCase(updateProductService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(updateProductService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(updateProductService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
